export default [
  /** 活动 开始 */
  {
    path: '/activity/coCreation',
    name: 'CoCreation',
    component: () => import(/* webpackChunkName: "CoCreation" */ '../../views/activity/coCreation/CoCreation.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/activity/coResult',
    name: 'CoCreationResult',
    component: () => import(/* webpackChunkName: "coCreationResult" */ '../../views/activity/coCreation/Result.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/activity/coCollectResult',
    name: 'CoCreationCollectResult',
    component: () =>
      import(/* webpackChunkName: "coCreationCollectResult" */ '../../views/activity/coCreation/CollectResult.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/activity/coPreVote',
    name: 'PreVote',
    component: () => import(/* webpackChunkName: "coPreVote" */ '../../views/activity/coCreation/PreVote.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/activity/coVote',
    name: 'Vote',
    component: () => import(/* webpackChunkName: "coVote" */ '../../views/activity/coCreation/Vote.vue'),
    meta: {
      title: '',
    },
  },
  /** 活动 结束 */
]
